import { render } from "./BaseImageElement.vue?vue&type=template&id=75104890&scoped=true&ts=true"
import script from "./BaseImageElement.vue?vue&type=script&lang=ts"
export * from "./BaseImageElement.vue?vue&type=script&lang=ts"

import "./BaseImageElement.vue?vue&type=style&index=0&id=75104890&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75104890"]])

export default __exports__